import { Children, isValidElement } from 'react';
import { Flex, FlexProps } from '../../../../atoms';
import { OutletHeader } from './outlet-header';
import { OutletMain } from './outlet-main';

export function OutletScrollable({
  children,
  ...rest
}: FlexProps): JSX.Element {
  let header: JSX.Element | null = null;
  let main: JSX.Element | null = null;

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }
    if (child.type === OutletHeader) {
      header = child;
    }
    if (child.type === OutletMain) {
      main = child;
    }
  });

  return (
    <Flex
      w="100%"
      flexDirection="column"
      overflowX="hidden"
      flexGrow={1}
      overflowY="auto"
      {...rest}
    >
      {header && header}
      {main && main}
    </Flex>
  );
}
